import lazyLoading from './lazyLoading'
import Apis from '../../../core/Apis'

export default {
    path: '/task',
    component: lazyLoading('taskmanage', true),
    meta: {
        icon: 'fa fa-cog fa-fw menu-icon',
        label: '任务管理',
        expanded: false,
        noRedirect: true
    },
    children: [
        {
            name: 'TaskList',
            path: 'index',
            component: lazyLoading('taskmanage/TaskManage'), // 加载模块
            meta: {
                label: '任务管理',
                hidden: true,
                auth: {
                    needApis: [Apis.bzxt.mission.list]
                }
            }
        },
        {
            name: 'TaskNew',
            path: 'new',
            component: lazyLoading('taskmanage/New'), // 加载模块
            meta: {
                label: '新建任务',
                parent: 'TaskList',
                nomenu: true
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/taskmanage.js